import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  TemplateRef,
} from '@angular/core';
import { BusinessCalendarEvent } from '../../models/calendar.model';
import {
  CalendarFilledIconComponent,
  CloseIconComponent,
  ClockIconComponent,
  TagRightIconComponent,
  RepeatIconComponent,
} from '@kuiper/icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { CalendarHelper } from '../../helpers/calendar/calendar.helper';
import { LongTextViewComponent } from '../../../../ui-components/lib/long-text-view/long-text-view.component';
import { UserDropdownViewComponent } from '../../../../ui-components/lib/user-dropdown-view/user-dropdown-view.component';
import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { ViewFileComponent } from '../view-file/view-file.component';
import { CALENDAR_EVENT_SOURCE_TYPE } from '../../constants/calendar-event-color';
import { TippyTooltipDirective } from '../../../../ui-components/lib/tooltip/tippy-tooltip.directive';
import { TenantService } from '../../services/tenant/tenant.service';
import { EMPLOYEE_ROUTES } from '../../constants/employee.routing.constants';
@Component({
  selector: 'lib-calendar-event-modal',
  imports: [
    CalendarFilledIconComponent,
    CloseIconComponent,
    UserDropdownViewComponent,
    TranslocoPipe,
    ClockIconComponent,
    DatePipe,
    TagRightIconComponent,
    LongTextViewComponent,
    NgTemplateOutlet,
    ViewFileComponent,
    RepeatIconComponent,
    TippyTooltipDirective,
  ],
  templateUrl: './calendar-event-modal.component.html',
  styleUrl: './calendar-event-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'contents',
  },
})
export class CalendarEventModalComponent {
  readonly calendarHelper = inject(CalendarHelper);
  private readonly tenantService = inject(TenantService);

  readonly CALENDAR_EVENT_SOURCE_TYPE = CALENDAR_EVENT_SOURCE_TYPE;
  readonly VIEW_EVENT_REQUEST_ROUTE = this.tenantService.tenantPath(
    `${EMPLOYEE_ROUTES.MY_INBOX.REQUEST}/${EMPLOYEE_ROUTES.REQUESTS.ACTION.VIEW}`
  );

  eventActionsTemplate = input<TemplateRef<unknown> | null>(null);
  closeEventDetails = output<void>();

  event = computed<BusinessCalendarEvent | null>(() =>
    this.calendarHelper.selectedEvent()
  );
  occurrenceStart = computed<Date | string | null>(
    () =>
      this.calendarHelper.selectedOccurrenceStart() ??
      this.event()?.started_at ??
      null
  );
  occurrenceEnd = computed<Date | string | null>(
    () =>
      this.calendarHelper.selectedOccurrenceEnd() ??
      this.event()?.ended_at ??
      null
  );

  handleCloseEventDetails(): void {
    this.closeEventDetails.emit();
  }
}
